import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// FaYoutube add kiya gaya hai
import { FaArrowRight, FaShoppingCart, FaChevronLeft, FaChevronRight, FaShareAlt, FaFacebook, FaWhatsapp, FaTwitter, FaYoutube } from 'react-icons/fa';
// WhatsApp utility import
import { sendToWhatsApp } from '../components/whatsappUtils';

import HeroImage from '../assets/hero.webp';
import Hero1Image from '../assets/hero1.webp';
import Hero2Image from '../assets/hero3.webp';
import fallbackImage1 from '../assets/fallback1.webp';
import fallbackImage2 from '../assets/fallback2.webp';
import seed from '../assets/seed.webp';
import croppest from '../assets/croppest.webp';
import scheme from '../assets/scheme.webp';

// Product images
import seed1 from '../assets/seed1.webp';
import seed2 from '../assets/seed2.webp';
import seed3 from '../assets/seed3.webp';
import Fertilizers1 from '../assets/Fertilizers1.webp';
import Fertilizers2 from '../assets/Fertilizers2.webp';
import machine1 from '../assets/machine1.webp';
import machine2 from '../assets/machine2.webp';
import Irrigation1 from '../assets/Irrigation1.webp';

const SEO = ({ 
  title = "कृषि सहायता - किसानों के लिए उन्नत कृषि समाधान", 
  description = "किसानों की आय बढ़ाने के लिए उन्नत कृषि तकनीक, सरकारी योजनाएं, बीज, उर्वरक और कृषि यंत्रों की जानकारी। जैविक खेती और आधुनिक सिंचाई तकनीकों के बारे में जानें।, how to start organic farming in India, best farming techniques for beginners,profitable agriculture business ideas, Kheti, kheti, beej, gehu", 
  keywords = "कृषि, किसान, जैविक खेती, सरकारी योजनाएं, कृषि यंत्र, बीज, उर्वरक, सिंचाई, फसल संरक्षण, किसान क्रेडिट कार्ड,agribusiness ideas, agriculture business plan, kheti, agriculture business plan, farming business ideas, agri startup ideas, agriculture market trends, crop marketing strategies, agricultural products suppliers, farm equipment business, agriculture export opportunities, value addition in agriculture",
  image = HeroImage,
  url = window.location.href,
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="hi_IN" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

const AgricultureWebsite = () => {
  // State for slider
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // State for blogs
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [blogImages, setBlogImages] = useState({});
  const [authorImages, setAuthorImages] = useState({});
  const [showShareOptions, setShowShareOptions] = useState({});
  
  // Products data
  const products = [
    {
      id: 1,
      name: 'गेहूँ का बीज (उन्नत किस्म)',
      price: '₹1200',
      category: 'बीज',
      image: seed1,
      description: 'उच्च उत्पादन देने वाली गेहूँ की उन्नत किस्म, रोग प्रतिरोधक क्षमता युक्त'
    },
    {
      id: 2,
      name: 'धान का हाइब्रिड बीज',
      price: '₹1500',
      category: 'बीज',
      image: seed2,
      description: 'उच्च उत्पादकता वाला धान का बीज, कम पानी में अच्छी पैदावार'
    },
    {
      id: 3,
      name: 'मक्का संकर बीज',
      price: '₹1800',
      category: 'बीज',
      image: seed3,
      description: 'उच्च प्रोटीन युक्त मक्का बीज, 90-100 दिन में तैयार'
    },
    {
      id: 4,
      name: 'जैविक खाद 25kg',
      price: '₹899',
      category: 'उर्वरक',
      image: Fertilizers1,
      description: '100% प्राकृतिक जैविक खाद, मिट्टी की उर्वरता बढ़ाने के लिए उत्तम'
    },
    {
      id: 5,
      name: 'यूरिया खाद 50kg',
      price: '₹1200',
      category: 'उर्वरक',
      image: Fertilizers2,
      description: 'नाइट्रोजन युक्त उर्वरक, फसलों की वृद्धि के लिए आवश्यक'
    },
    {
      id: 6,
      name: 'मिनी ट्रैक्टर',
      price: '₹1,85,000',
      category: 'कृषि यंत्र',
      image: machine1,
      description: 'छोटे किसानों के लिए उपयुक्त शक्तिशाली मिनी ट्रैक्टर'
    },
    {
      id: 7,
      name: 'थ्रेशर मशीन',
      price: '₹45,000',
      category: 'कृषि यंत्र',
      image: machine2,
      description: 'फसल कटाई के बाद अनाज निकालने की मशीन'
    },
    {
      id: 8,
      name: 'ड्रिप सिंचाई किट',
      price: '₹3,500',
      category: 'सिंचाई उपकरण',
      image: Irrigation1,
      description: 'पानी की बचत करने वाली आधुनिक सिंचाई प्रणाली'
    },
    {
      id: 9,
      name: 'नीम आधारित कीटनाशक',
      price: '₹450',
      category: 'कीटनाशक',
      image: HeroImage,
      description: 'प्राकृतिक नीम से बना कीटनाशक, सभी फसलों के लिए सुरक्षित'
    }
  ];

  const [activeProductIndex, setActiveProductIndex] = useState(0);

  // Slider images
  const sliderImages = [
    {
      url: HeroImage,
      title: 'किसानों की सफलता की कहानी',
      subtitle: 'हमारे किसान भाइयों ने जैविक खेती से आय दोगुनी की',
      ctaLink: '/blog'
    },
    {
      url: Hero1Image,
      title: 'मिट्टी जांच अभियान',
      subtitle: 'मुफ्त मिट्टी परीक्षण - जानें अपनी मिट्टी की सेहत',
      ctaLink: '/services'
    },
    {
      url: Hero2Image,
      title: 'किसान क्रेडिट कार्ड सुविधा',
      subtitle: 'कम ब्याज दर पर कृषि ऋण पाने का सरल तरीका',
      ctaLink: '/government-schemes'
    }
  ];

  // Auto slide change
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [sliderImages.length]);

  // Function to check if image exists
  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };

  // Find valid image URL for blog posts
  const findValidImageUrl = async (postId) => {
    const formats = ['jpg', 'jpeg', 'png', 'gif'];
    
    for (const format of formats) {
      const imageUrl = `https://www.pcds.co.in/cpm/imagesarticle/b${postId}.${format}`;
      const exists = await checkImageExists(imageUrl);
      if (exists) return imageUrl;
    }
    
    return null; // No valid image found
  };

  // Fetch blogs and author images from API
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        // First fetch blog data
        const blogResponse = await fetch('https://www.pcds.co.in/blogapi.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ uri: 'get', limit: 6, category: 'latest' }),
        });

        if (!blogResponse.ok) {
          throw new Error(`HTTP error! status: ${blogResponse.status}`);
        }

        const blogData = await blogResponse.json();
        
        if (Array.isArray(blogData)) {
          // Process blog images like in blog.jsx
          const blogImageUrls = {};
          for (const blog of blogData) {
            if (blog.id) {
              const validImageUrl = await findValidImageUrl(blog.id);
              blogImageUrls[blog.id] = validImageUrl || (blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2);
            } else {
              blogImageUrls[blog.id] = blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2;
            }
          }

          setBlogs(blogData);
          setBlogImages(blogImageUrls);

          // Now fetch author images for each unique author
          const uniqueAuthors = [...new Set(blogData.map(blog => blog.username || 'admin'))];
          const authorImgMap = {};
          
          await Promise.all(uniqueAuthors.map(async (author) => {
            try {
              const authorResponse = await fetch(`https://www.plugflare.com/authorapi.php?username=${author}`);
              if (authorResponse.ok) {
                const authorData = await authorResponse.json();
                if (authorData.imageUrl) {
                  authorImgMap[author] = authorData.imageUrl;
                }
              }
            } catch (error) {
              console.error(`Error fetching author image for ${author}:`, error);
            }
          }));

          setAuthorImages(authorImgMap);
        } else {
          console.error('Expected an array but got:', blogData);
          setBlogs([]);
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
        // Fallback to mock data if API fails
        const mockBlogs = [
          {
            id: 1,
            title: 'जैविक खेती से कैसे बढ़ाएं अपनी आय',
            body: 'जैविक खेती के तरीके और इसके फायदों के बारे में विस्तृत जानकारी...',
            username: 'user123',
            viewcount: 1250
          },
          {
            id: 2,
            title: 'मिट्टी की सेहत सुधारने के 5 आसान उपाय',
            body: 'मिट्टी की गुणवत्ता कैसे बढ़ाएं और फसल उत्पादन कैसे बेहतर करें...',
            username: 'expert456',
            viewcount: 980
          },
          {
            id: 3,
            title: 'ड्रिप सिंचाई से पानी की बचत',
            body: 'ड्रिप सिंचाई तकनीक और इसके लाभों के बारे में पूरी जानकारी...',
            username: 'admin',
            viewcount: 750
          },
          {
            id: 4,
            title: 'किसान क्रेडिट कार्ड के लाभ',
            body: 'किसान क्रेडिट कार्ड योजना के बारे में पूरी जानकारी और आवेदन प्रक्रिया...',
            username: 'user789',
            viewcount: 1100
          },
          {
            id: 5,
            title: 'फसल चक्रण के फायदे',
            body: 'फसल चक्रण क्या है और यह कैसे मिट्टी की उर्वरता बनाए रखने में मदद करता है...',
            username: 'expert101',
            viewcount: 850
          },
          {
            id: 6,
            title: 'रबी फसलों की उन्नत किस्में',
            body: 'रबी सीजन के लिए सर्वश्रेष्ठ फसल किस्में और उनकी विशेषताएं...',
            username: 'admin',
            viewcount: 920
          }
        ];
        setBlogs(mockBlogs);
        
        // Set fallback images for mock blogs
        const mockBlogImages = {};
        mockBlogs.forEach(blog => {
          mockBlogImages[blog.id] = blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2;
        });
        setBlogImages(mockBlogImages);
        
        setAuthorImages({}); // Empty object - no author images will be shown
      } finally {
        setLoading(false);
      }
    };
    
    fetchBlogs();
  }, []);

  // Toggle share options for a blog
  const toggleShareOptions = (blogId) => {
    setShowShareOptions(prev => ({
      ...prev,
      [blogId]: !prev[blogId]
    }));
  };

  // Share blog on different platforms
  const shareBlog = (platform, blog) => {
    const blogUrl = `${window.location.origin}${getBlogUrl(blog)}`;
    const shareText = `Check out this blog: ${blog.title}`;
    
    switch(platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(blogUrl)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(`${shareText} ${blogUrl}`)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(blogUrl)}`, '_blank');
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: blog.title,
            text: shareText,
            url: blogUrl
          }).catch(err => console.log('Error sharing:', err));
        } else {
          // Fallback for browsers that don't support Web Share API
          const textArea = document.createElement('textarea');
          textArea.value = `${shareText}\n${blogUrl}`;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          alert('Link copied to clipboard!');
        }
    }
  };

  // Product carousel functionality
  const productContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [autoScroll, setAutoScroll] = useState(true);
  const [scrollInterval, setScrollInterval] = useState(null);

  useEffect(() => {
    if (!autoScroll) return;
    
    const container = productContainerRef.current;
    if (!container) return;

    const scroll = () => {
      if (!container) return;
      
      const maxScroll = container.scrollWidth - container.clientWidth;
      const currentScroll = container.scrollLeft;
      
      if (currentScroll >= maxScroll - 10) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
        setActiveProductIndex(0);
      } else {
        const productWidth = container.querySelector('.product-card').offsetWidth + 24;
        const nextScroll = Math.min(currentScroll + productWidth, maxScroll);
        const productsPerView = Math.floor(container.clientWidth / productWidth);
        setActiveProductIndex(prev => (prev + 1) % (products.length - productsPerView + 1));
        container.scrollTo({ left: nextScroll, behavior: 'smooth' });
      }
    };

    const interval = setInterval(scroll, 3000);
    setScrollInterval(interval);
    
    return () => clearInterval(interval);
  }, [autoScroll, products.length]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - productContainerRef.current.offsetLeft);
    setScrollLeft(productContainerRef.current.scrollLeft);
    setAutoScroll(false);
    if (scrollInterval) clearInterval(scrollInterval);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setAutoScroll(true);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    setAutoScroll(true);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - productContainerRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    productContainerRef.current.scrollLeft = scrollLeft - walk;
    
    const container = productContainerRef.current;
    if (container) {
      const productWidth = container.querySelector('.product-card').offsetWidth + 24;
      const newIndex = Math.round(container.scrollLeft / productWidth);
      setActiveProductIndex(Math.min(newIndex, products.length - 1));
    }
  };

  const scrollProducts = (direction) => {
    const container = productContainerRef.current;
    if (!container) return;
    
    setAutoScroll(false);
    if (scrollInterval) clearInterval(scrollInterval);
    
    const productWidth = container.querySelector('.product-card').offsetWidth + 24;
    const scrollAmount = direction === 'left' ? -productWidth : productWidth;
    
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    
    setActiveProductIndex(prev => {
      if (direction === 'left') {
        return Math.max(0, prev - 1);
      } else {
        const productsPerView = Math.floor(container.clientWidth / productWidth);
        return Math.min(prev + 1, products.length - productsPerView);
      }
    });
    
    setTimeout(() => setAutoScroll(true), 5000);
  };

  const scrollToProduct = (index) => {
    const container = productContainerRef.current;
    if (!container) return;
    
    setAutoScroll(false);
    if (scrollInterval) clearInterval(scrollInterval);
    
    const productWidth = container.querySelector('.product-card').offsetWidth + 24;
    container.scrollTo({ left: index * productWidth, behavior: 'smooth' });
    setActiveProductIndex(index);
    setTimeout(() => setAutoScroll(true), 5000);
  };

  // Color themes for UI elements
  const colorThemes = [
    { bg: 'bg-green-100', border: 'border-green-200', hover: 'hover:bg-green-200' },
    { bg: 'bg-amber-100', border: 'border-amber-200', hover: 'hover:bg-amber-200' },
    { bg: 'bg-teal-100', border: 'border-teal-200', hover: 'hover:bg-teal-200' }
  ];

  // Function to clean HTML tags from description
  const cleanDescription = (html) => {
    if (!html) return '';
    // Remove HTML tags and trim whitespace
    const text = html.replace(/<[^>]*>?/gm, '').trim();
    // Return first 100 characters with ellipsis if needed
    return text.length > 100 ? `${text.substring(0, 100)}...` : text;
  };

  // Generate proper blog URLs like in blog.jsx
  const getBlogUrl = (blog) => {
    // Check if URL field contains a valid path
    if (blog.url) {
      const urlParts = blog.url.split('/');
      const lastPart = urlParts[urlParts.length - 1];
      if (lastPart && lastPart !== 'undefined') {
        return `/blog/${lastPart}`;
      }
    }
    
    // Fallback to ID-based URL if no valid URL
    return `/blog/post-${blog.id}`;
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E6F4EA', marginTop: '80px' }}>
      <SEO />
      
      {/* Hero Slider Section */}
      <section className="relative h-96 overflow-hidden w-full">
        {sliderImages.map((slide, index) => (
          <div 
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
          >
            <img 
              src={slide.url} 
              alt={slide.title} 
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
              <div className="text-center px-4">
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 animate-fadeIn">
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-yellow-300">
                    {slide.title}
                  </span>
                </h1>
                <p className="text-xl text-white mb-6">{slide.subtitle}</p>
                <Link 
                  to={slide.ctaLink} 
                  className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 transform hover:scale-105"
                >
                  और जानें
                </Link>
              </div>
            </div>
          </div>
        ))}
        <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2 z-20">
          {sliderImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-gray-400'}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* About Us Section */}
      <section className="py-12 px-4 w-full">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-blue-600">
                About Our Farm
              </span>
            </h2>
            <p className="max-w-3xl mx-auto text-gray-700">
              हम छोटे किसानों की आय बढ़ाने के लिए काम करते हैं। कम लागत, अधिक उपज के तरीके सिखाते हैं।
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="md:w-1/2 w-full">
              {/* VIDEO SECTION UPDATED: Replaced iframe with Clickable Thumbnail */}
              <a 
                href="https://youtu.be/vPA2ppartmw?si=_2LoOkUa6rf6tw6z" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block relative rounded-xl overflow-hidden shadow-lg transform transition duration-500 hover:scale-105 group"
              >
                {/* YouTube Thumbnail Image */}
                <img 
                  src="https://img.youtube.com/vi/aft1Th2SWIs/maxresdefault.jpg" 
                  alt="Unnat Kheti Video" 
                  className="w-full h-64 md:h-80 object-cover"
                />
                
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all">
                  <div className="bg-red-600 text-white rounded-full p-4 shadow-xl group-hover:scale-110 transition-transform duration-300">
                    <FaYoutube size={48} />
                  </div>
                </div>
              </a>
            </div>
            <div className="md:w-1/2 w-full">
              <p className="mb-3 text-gray-700">
                इसी प्रकार की और अधिक जानकारीपूर्ण वीडियो देखने के लिए हमारे यूट्यूब चैनल को सब्सक्राइब करें। 
              </p>
              <a href="https://www.youtube.com/@unnatkhetiofficial" className="text-green-600 font-semibold hover:underline" target="_blank" rel="noopener noreferrer">
                Visit our YouTube Channel
              </a>
            
              <h3 className="text-xl md:text-2xl font-semibold mb-3 text-gray-800 mt-4">हमारा अनुभव</h3>
              <p className="mb-3 text-gray-700">
                15 सालों से हम 10,000+ किसानों को प्रशिक्षित कर चुके हैं। हमारे किसान साथियों ने जैविक खेती से लागत 40% कम की और आय 70% तक बढ़ाई।
              </p>
              <p className="mb-4 text-gray-700">
                हम सिखाते हैं: 
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>मिट्टी की सेहत सुधारने के तरीके</li>
                <li>कम पानी में अच्छी फसल लेना</li>
                <li>बिना रसायन कीट नियंत्रण</li>
                <li>फसल का बेहतर दाम पाने के उपाय</li>
              </ul>
              <Link to="/about">
                <button className="flex items-center font-medium group text-green-700 mt-4">
                  हमारे सफल किसानों की कहानियाँ पढ़ें
                  <FaArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 w-full bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-2 text-gray-800">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-green-600">
                हमारी सेवाएं
              </span>
            </h2>
            <p className="max-w-3xl mx-auto text-gray-800">
              किसानों की सभी आवश्यकताओं के लिए व्यापक समाधान
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Service Card 1 - सरकारी योजनाएं */}
            <div className="rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-gray-200 bg-white">
              <div className="relative overflow-hidden">
                <img 
                  src={scheme} 
                  alt="सरकारी योजनाएं" 
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="text-2xl mr-3">🏛</span>
                  <h3 className="text-xl font-semibold text-gray-800">सरकारी योजनाएं</h3>
                </div>
                <p className="mb-4 text-gray-700">
                  किसानों के लिए सरकारी योजनाओं की पूरी जानकारी और आवेदन प्रक्रिया
                </p>
                <ul className="mb-4 space-y-2">
                  {[
                    "प्रधानमंत्री किसान सम्मान निधि",
                    "किसान क्रेडिट कार्ड योजना",
                    "फसल बीमा योजना",
                    "सब्सिडी पर कृषि यंत्र"
                  ].map((item, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/government-schemes" className="font-medium flex items-center text-gray-800">
                  और जानें
                  <FaArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
            
            {/* Service Card 2 - बीज जानकारी */}
            <div className="rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-gray-200 bg-white">
              <div className="relative overflow-hidden">
                <img 
                  src={seed} 
                  alt="बीज जानकारी" 
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="text-2xl mr-3">🌾</span>
                  <h3 className="text-xl font-semibold text-gray-800">बीज जानकारी</h3>
                </div>
                <p className="mb-4 text-gray-700">
                  विभिन्न फसलों के उन्नत बीजों की जानकारी और उनका सही उपयोग
                </p>
                <ul className="mb-4 space-y-2">
                  {[
                    "उन्नत किस्मों के बीज",
                    "बीज उपचार विधि",
                    "बीज संरक्षण तकनीक",
                    "बीज दर और बुआई विधि"
                  ].map((item, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-green-500 mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/seed-information" className="font-medium flex items-center text-gray-800">
                  और जानें
                  <FaArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
            
            {/* Service Card 3 - फसल रोग नियंत्रण */}
            <div className="rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-gray-200 bg-white">
              <div className="relative overflow-hidden">
                <img 
                  src={croppest} 
                  alt="फसल रोग नियंत्रण" 
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="text-2xl mr-3">🐛</span>
                  <h3 className="text-xl font-semibold text-gray-800">फसल रोग नियंत्रण</h3>
                </div>
                <p className="mb-4 text-gray-700">
                  फसलों में लगने वाले प्रमुख रोगों और कीटों की पहचान व नियंत्रण
                </p>
                <ul className="mb-4 space-y-2">
                  {[
                    "रोगों की पहचान कैसे करें",
                    "जैविक नियंत्रण विधियाँ",
                    "रासायनिक उपचार",
                    "समेकित नाशीजीव प्रबंधन"
                  ].map((item, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-red-500 mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/crop-pest-disease-control" className="font-medium flex items-center text-gray-800">
                  और जानें
                  <FaArrowRight className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Blog Section */}
      <section className="py-16 px-4 w-full bg-green-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-2 text-gray-800">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-500">
                Latest Blog Posts
              </span>
            </h2>
            <p className="max-w-3xl mx-auto text-gray-800">
              आधुनिक कृषि में नवीनतम रुझानों और तकनीकों के साथ अपडेट रहें
            </p>
          </div>
          
          {loading ? (
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
            </div>
          ) : blogs.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-gray-600">No blog posts found</p>
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                {blogs.slice(0, 3).map((blog, index) => {
                  const blogUrl = getBlogUrl(blog);
                  const theme = colorThemes[index % colorThemes.length];
                  const blogImage = blogImages[blog.id] || (blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2);
                  const cleanDesc = cleanDescription(blog.body);
                  
                  return (
                    <div 
                      key={blog.id} 
                      className={`rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 ${theme.bg} border ${theme.border}`}
                    >
                      <div className="relative overflow-hidden h-48">
                        <img 
                          src={blogImage} 
                          alt={blog.title} 
                          className="w-full h-full object-cover"
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2;
                          }}
                        />
                        <button 
                          onClick={() => toggleShareOptions(blog.id)}
                          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors"
                          aria-label="Share options"
                        >
                          <FaShareAlt className="text-gray-700" />
                        </button>
                        {showShareOptions[blog.id] && (
                          <div className="absolute top-12 right-2 bg-white p-2 rounded-lg shadow-lg z-10 flex flex-col space-y-2">
                            <button 
                              onClick={() => shareBlog('facebook', blog)}
                              className="flex items-center text-blue-600 hover:text-blue-800"
                            >
                              <FaFacebook className="mr-2" /> Facebook
                            </button>
                            <button 
                              onClick={() => shareBlog('whatsapp', blog)}
                              className="flex items-center text-green-600 hover:text-green-800"
                            >
                              <FaWhatsapp className="mr-2" /> WhatsApp
                            </button>
                            <button 
                              onClick={() => shareBlog('twitter', blog)}
                              className="flex items-center text-blue-400 hover:text-blue-600"
                            >
                              <FaTwitter className="mr-2" /> Twitter
                            </button>
                            <button 
                              onClick={() => shareBlog('other', blog)}
                              className="flex items-center text-gray-700 hover:text-gray-900"
                            >
                              <FaShareAlt className="mr-2" /> Other
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-semibold mb-2 text-gray-800">
                          <Link to={blogUrl}>{blog.title}</Link>
                        </h3>
                        <p className="mb-4 text-gray-700">{cleanDesc}</p>
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex items-center">
                            {authorImages[blog.username || 'admin'] && (
                              <img 
                                src={authorImages[blog.username || 'admin']} 
                                alt={blog.username || 'Admin'} 
                                className="w-8 h-8 rounded-full mr-2 object-cover"
                                loading="lazy"
                              />
                            )}
                            <span className="text-sm text-gray-600">By: {blog.username || 'Admin'}</span>
                          </div>
                          <span className="text-sm text-gray-600">Views: {blog.viewcount || 0}</span>
                        </div>
                        <Link 
                          to={blogUrl}
                          className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-full flex items-center justify-center transition-colors duration-300"
                        >
                          Read More <FaArrowRight className="ml-2" />
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                {blogs.slice(3, 6).map((blog, index) => {
                  const blogUrl = getBlogUrl(blog);
                  const theme = colorThemes[(index + 3) % colorThemes.length];
                  const blogImage = blogImages[blog.id] || (blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2);
                  const cleanDesc = cleanDescription(blog.body);
                  
                  return (
                    <div 
                      key={blog.id} 
                      className={`rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 ${theme.bg} border ${theme.border}`}
                    >
                      <div className="relative overflow-hidden h-48">
                        <img 
                          src={blogImage} 
                          alt={blog.title} 
                          className="w-full h-full object-cover"
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = blog.id % 2 === 0 ? fallbackImage1 : fallbackImage2;
                          }}
                        />
                        <button 
                          onClick={() => toggleShareOptions(blog.id)}
                          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 transition-colors"
                          aria-label="Share options"
                        >
                          <FaShareAlt className="text-gray-700" />
                        </button>
                        {showShareOptions[blog.id] && (
                          <div className="absolute top-12 right-2 bg-white p-2 rounded-lg shadow-lg z-10 flex flex-col space-y-2">
                            <button 
                              onClick={() => shareBlog('facebook', blog)}
                              className="flex items-center text-blue-600 hover:text-blue-800"
                            >
                              <FaFacebook className="mr-2" /> Facebook
                            </button>
                            <button 
                              onClick={() => shareBlog('whatsapp', blog)}
                              className="flex items-center text-green-600 hover:text-green-800"
                            >
                              <FaWhatsapp className="mr-2" /> WhatsApp
                            </button>
                            <button 
                              onClick={() => shareBlog('twitter', blog)}
                              className="flex items-center text-blue-400 hover:text-blue-600"
                            >
                              <FaTwitter className="mr-2" /> Twitter
                            </button>
                            <button 
                              onClick={() => shareBlog('other', blog)}
                              className="flex items-center text-gray-700 hover:text-gray-900"
                            >
                              <FaShareAlt className="mr-2" /> Other
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="p-6">
                        <h3 className="text-xl font-semibold mb-2 text-gray-800">
                          <Link to={blogUrl}>{blog.title}</Link>
                        </h3>
                        <p className="mb-4 text-gray-700">{cleanDesc}</p>
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex items-center">
                            {authorImages[blog.username || 'admin'] && (
                              <img 
                                src={authorImages[blog.username || 'admin']} 
                                alt={blog.username || 'Admin'} 
                                className="w-8 h-8 rounded-full mr-2 object-cover"
                                loading="lazy"
                              />
                            )}
                            <span className="text-sm text-gray-600">By: {blog.username || 'Admin'}</span>
                          </div>
                          <span className="text-sm text-gray-600">Views: {blog.viewcount || 0}</span>
                        </div>
                        <Link 
                          to={blogUrl}
                          className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-full flex items-center justify-center transition-colors duration-300"
                        >
                          Read More <FaArrowRight className="ml-2" />
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              <div className="text-center mt-8">
                <Link to="/blog">
                  <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center">
                    View All Blog Posts <FaArrowRight className="ml-2" />
                  </button>
                </Link>
              </div>
            </>
          )}
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 w-full bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-2 text-gray-800">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-green-600">
                Our Products
              </span>
            </h2>
            <p className="max-w-3xl mx-auto text-gray-800">
              आपकी सभी कृषि आवश्यकताओं के लिए उच्च गुणवत्ता वाले कृषि उत्पाद
            </p>
          </div>
          
          <div className="relative">
            <button 
              onClick={() => scrollProducts('left')}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition-colors duration-300 flex items-center justify-center"
              style={{ marginLeft: '-1rem', width: '44px', height: '44px' }}
              disabled={activeProductIndex === 0}
            >
              <FaChevronLeft className={`text-gray-700 text-lg ${activeProductIndex === 0 ? 'opacity-50' : ''}`} />
            </button>
            
            <div 
              ref={productContainerRef}
              className="flex overflow-x-auto pb-6 scrollbar-hide gap-6 cursor-grab"
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
              style={{ scrollSnapType: 'x mandatory' }}
            >
              {products.map((product, index) => {
                const theme = colorThemes[index % colorThemes.length];
                
                return (
                  <div 
                    key={product.id} 
                    className={`flex-shrink-0 w-72 rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border ${theme.border} ${theme.hover} product-card`}
                    style={{ 
                      backgroundColor: '#FFFFFF',
                      scrollSnapAlign: 'start'
                    }}
                  >
                    <div className="relative h-56 overflow-hidden">
                      <img 
                        src={product.image} 
                        alt={product.name} 
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                        loading="lazy"
                      />
                      <span className="absolute top-2 right-2 bg-green-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                        {product.price}
                      </span>
                      <span className="absolute bottom-2 left-2 bg-white text-gray-800 text-xs font-medium px-2 py-1 rounded-full">
                        {product.category}
                      </span>
                    </div>
                    <div className="p-4">
                      <h3 className="text-lg font-semibold mb-2 text-gray-800">{product.name}</h3>
                      <p className="text-sm text-gray-600 mb-3 line-clamp-2">{product.description}</p>
                      {/* Updated WhatsApp Order Button */}
                      <button 
                        onClick={() => sendToWhatsApp(product.name, product.price, product.category, 1)}
                        className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-full flex items-center justify-center transition-colors duration-300"
                      >
                        <FaShoppingCart className="mr-2" />
                        अभी ऑर्डर करें
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            
            <button 
              onClick={() => scrollProducts('right')}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-md hover:bg-gray-100 transition-colors duration-300 flex items-center justify-center"
              style={{ marginRight: '-1rem', width: '44px', height: '44px' }}
              disabled={activeProductIndex >= products.length - 3}
            >
              <FaChevronRight className={`text-gray-700 text-lg ${activeProductIndex >= products.length - 3 ? 'opacity-50' : ''}`} />
            </button>
          </div>
          
          <div className="flex justify-center mt-6 space-x-2">
            {products.map((_, index) => (
              <button
                key={index}
                onClick={() => scrollToProduct(index)}
                className={`w-3 h-3 rounded-full ${index === activeProductIndex ? 'bg-green-600' : 'bg-gray-300'}`}
                aria-label={`Go to product ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 w-full bg-gradient-to-r from-green-600 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Farming Experience?</h2>
          <p className="text-xl mb-8 opacity-90 max-w-4xl mx-auto">
            सैकड़ों किसानों में शामिल हों जो पहले से ही हमारे उत्पादों और सेवाओं का लाभ उठा रहे हैं
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/products">
              <button className="bg-white text-green-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105">
                Get Started Today
              </button>
            </Link>
            <Link to="/contact">
              <button className="bg-transparent border-2 border-white hover:bg-white hover:bg-opacity-10 font-bold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105">
                Contact Our Experts
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgricultureWebsite;